export const ASSET_CHAT_API_PATH = "/api/asset-chat";

/**
 * Starter questions shown in the empty state. Generic across assets for the MVP;
 * could become per-asset later. Keep to 4 (renders as a 2×2 grid).
 */
export const ASSET_CHAT_SUGGESTIONS = [
    "Summarize the key risks",
    "What are the liquidity terms?",
    "What's the target return?",
    "Minimum & structure?",
] as const;
